export const WHEELBASE_CHECKOUT_CSS = `
:host {
  display: block;
  overflow: visible !important;
  background: transparent !important;
  font-family: "Helvetica Neue", Calibri, system-ui, sans-serif;
  color: var(--alt-blk, #172B2D);
}

.min-h-screen {
  min-height: 0 !important;
  overflow: visible !important;
  background: transparent !important;
  max-width: none !important;
  width: 100% !important;
}

.bg-surfacecol-content,
.grid.h-\\[30rem\\],
.overflow-hidden:has(.grid.h-\\[30rem\\]),
.col-span-full.lg\\:col-span-10,
.container-main.grid:last-of-type {
  display: none !important;
}

.pb-20 {
  padding-bottom: 0 !important;
}

.grid-cols-main.container-main,
.grid-cols-main {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  grid-template-columns: none !important;
}

.lg\\:col-span-5,
.lg\\:col-start-12,
.lg\\:row-start-1 {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  grid-column: auto !important;
  grid-row: auto !important;
}

.lg\\:sticky {
  position: static !important;
}

/* Compact in-flow card + sticky footer CTA. We keep the full bill on all breakpoints. */
.lg\\:hidden {
  display: none !important;
}

#bill-section-container {
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box !important;
  border-radius: 1.5rem !important;
  border: 1px solid rgb(228 228 231) !important;
  padding: 2rem !important;
  background: #ffffff !important;
  box-shadow: 0 1px 2px rgb(0 0 0 / 0.06);
}

/* Date modal + overlay must cover the viewport, not the sidebar card. */
.bf-g9-vf,
.bf-6A-t3 {
  position: fixed !important;
  inset: 0 !important;
  z-index: 80 !important;
}

.bf-X-ej- {
  max-height: min(90vh, 52rem);
  overflow: auto !important;
}

/* Delivery dialog sets overflow-visible so extra fields paint outside the card. */
.bf-hnI4z:not(.bf-X-ej-) {
  max-height: min(90vh, 52rem) !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

.bf-hnI4z:not(.bf-X-ej-) .bf-Z4TP1 {
  overflow-y: auto !important;
  min-height: 0 !important;
  flex: 1 1 auto !important;
}

.bf-hnI4z:not(.bf-X-ej-) .bf-q22o-,
.bf-hnI4z:not(.bf-X-ej-) .bf-EJpze,
.bf-hnI4z:not(.bf-X-ej-) .bf-NU3Qo {
  flex-shrink: 0 !important;
}

.bf-hnI4z:not(.bf-X-ej-) .bf-NU3Qo {
  background: #ffffff !important;
}

.bf-2X1Pr,
.bf-2X1Pr .bf-kTIo- {
  background-color: #D32A46 !important;
  color: #ffffff !important;
}

img[alt="Wheelbase"],
.mt-4.flex.items-center.justify-center:has(img[alt="Wheelbase"]) {
  display: none !important;
}
`;

/** Same overlay rules, painted onto Wheelbase's body-level portal shadow. */
export const WHEELBASE_PORTAL_CSS = `
.bf-g9-vf,
.bf-6A-t3 {
  position: fixed !important;
  inset: 0 !important;
  z-index: 80 !important;
}

.bf-X-ej- {
  max-height: min(90vh, 52rem);
  overflow: auto !important;
}

.bf-hnI4z:not(.bf-X-ej-) {
  max-height: min(90vh, 52rem) !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

.bf-hnI4z:not(.bf-X-ej-) .bf-Z4TP1 {
  overflow-y: auto !important;
  min-height: 0 !important;
  flex: 1 1 auto !important;
}

.bf-hnI4z:not(.bf-X-ej-) .bf-q22o-,
.bf-hnI4z:not(.bf-X-ej-) .bf-EJpze,
.bf-hnI4z:not(.bf-X-ej-) .bf-NU3Qo {
  flex-shrink: 0 !important;
}

.bf-hnI4z:not(.bf-X-ej-) .bf-NU3Qo {
  background: #ffffff !important;
}

.bf-2X1Pr,
.bf-2X1Pr .bf-kTIo- {
  background-color: #D32A46 !important;
  color: #ffffff !important;
}

.bf-EfTGj .bf-2X1Pr {
  background-color: #D32A46 !important;
  color: #ffffff !important;
}

img[alt="Wheelbase"],
.mt-4.flex.items-center.justify-center:has(img[alt="Wheelbase"]) {
  display: none !important;
}
`;

const STYLE_ID = "ebm-wheelbase-skin";

export function paintWheelbaseShadow(host: Element, css: string): boolean {
  const root = (host as HTMLElement).shadowRoot;
  if (!root) {
    return false;
  }
  let style = root.getElementById(STYLE_ID) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement("style");
    style.id = STYLE_ID;
    root.appendChild(style);
  }
  if (style.textContent !== css) {
    style.textContent = css;
  }
  return true;
}

export function paintWheelbasePortals(css: string): void {
  document.querySelectorAll("[data-wb-widget-portal]").forEach((host) => {
    paintWheelbaseShadow(host, css);
  });
}
